import { useCoiReminder } from '../useCoiReminder';

type Result = ReturnType<typeof useCoiReminder>;

export function useSignFormOptions(): Result {
	return useCoiReminder();
}
